<template>
  <!--la referencia es única para cada clase-->
  <div
    ref="perimeterSymbology"
  >
    <v-card
      v-show="showPerimeterSymbology"
      color="#537582CC"
      dark
      elevation="6"
      width="590px"
      style="position: absolute; right: 63px; bottom: 50px"
    >
      <v-toolbar
        color="primary"
        dark
        dense
      >
        <v-toolbar-title
          class="text-symbology"
        >
          Simbología perímetros
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="toggleMinimize"
        >
          <v-icon>
            {{
              minimized ? "mdi-chevron-up" : "mdi-chevron-down"
            }}
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-container
        v-show="!minimized"
      >
        <SymbologyColorLineRow
          :lines="perimeterLines"
          :line-selected.sync="lineSelected"
          :color-selected.sync="colorSelected"
          :active-key="activeBtn"
          asset-base-path="new_simbologia"
          :preview-height="40"
          :preview-width="100"
          draw-event="polygon"
          draw-icon="esri-icon-polygon"
          draw-tooltip="Perímetro"
          @draw="startPerimeterDraw"
        />
      </v-container>
    </v-card>
    <!-- Snackbar finalizar TODOS los dibujos -->
    <v-snackbar
      v-model="showSnackBar"
      button
      :timeout="-1"
      color="#28a745"
      elevation="24"
      width="500px"
      height="30px"
      style="margin-bottom: 42px;"
    >
      <span
        style="font-size: 16px; padding: 4px;"
      >Añadir perímetro</span>
      <template
        #action="{ attrs }"
      >
        <v-btn
          text
          color="white"
          v-bind="attrs"
          @click="finishDrawing"
        >
          Aceptar
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Snackbar dibujo actual -->
    <v-snackbar
      v-model="isDrawing"
      button
      :timeout="-1"
    >
      Haz click en el mapa
      <template
        #action="{ attrs }"
      >
        <v-btn
          text
          color="pink"
          v-bind="attrs"
          @click="cancelCurrentDrawing"
        >
          Cancelar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as ArcGIS from '../../helpers/ArcGIS'

import SymbologyColorLineRow from './symbology/SymbologyColorLineRow.vue'
import { getCIMSymbol } from '@/helpers/GraphicsSimbology'

export default {
  components: { SymbologyColorLineRow },
  data: () => ({
    showPerimeterSymbology: false,
    callback: null,
    minimized: false,
    showSelectedColor: false,
    colorSelected: {},
    activeBtn: null,
    showSnackBar: false,
    isDrawing: false,
    graphics: [],
    lineSelected: null
  }),
  computed: {
    ...mapGetters('map', [
      'symbologyLines'
    ]),
    colorSelectedHex() {
      return this.colorSelected.hex
    },
    perimeterLines() {
      return this.symbologyLines.filter(elem => elem.isPerimetro)
    }
  },
  watch: {
    showPerimeterSymbology() {
      this.showSelectedColor = false
    }
  },
  mounted() {
    this.lineSelected = this.perimeterLines[0]
    this.colorSelected.rgba = {
      a: 0.7,
      b: 16,
      g: 16,
      r: 233
    }
    this.$eventHub.$on('showPerimeterSymbology', this.showPanelPerimeterSymbology)
  },
  methods: {
    showPanelPerimeterSymbology(data) {
      this.showPerimeterSymbology = true
      this.showSnackBar = true
      this.callback = data.callback // Funcion a la que se va a llamar al finalizar, se recibe por el eventhub y se le envian los graphics
      this.graphics = data.graphics

      this.$store.dispatch('map/setActiveDrawSymbologyPanel', 'perimeter')

      ArcGIS.initPerimetroSketchViewModel({
        callbackCreate: this.onDrawCreated,
        callbackUpdate: this.onDrawUpdated,
        callbackDelete: this.onDrawDeleted
      })
      ArcGIS.drawGraphicsPerimetro(this.graphics)
    },
    toggleMinimize() {
      this.minimized = !this.minimized
    },

    startPerimeterDraw(evt) {
      this.isDrawing = true
      this.activeBtn = `${evt}Button`

      const rgba = this.colorSelected.rgba
      const color = [
        rgba.r,
        rgba.g,
        rgba.b,
        Math.round(rgba.a * 255)
      ]

      const cimDefinition = getCIMSymbol(this.lineSelected.style, color)

      const event = {
        function: evt,
        color,
        typeLine: this.lineSelected.style,
        custom: true,
        label: this.lineSelected,
        cimSymbol: cimDefinition
      }
      ArcGIS.paintEventPerimetro(event)
    },

    // #region CALLBACKS ARCGIS
    onDrawCreated(data) {
      this.isDrawing = false
      this.activeBtn = null
      this.graphics.push(data)
    },
    onDrawUpdated(data) {
      const updatedAttributes = data.attributes
      const updatedGeometry = data.geometry

      const index = this.graphics.findIndex((x) =>
        this.parseAtributos(x.ATRIBUTOS).ID_GRAFICO === updatedAttributes.ID_GRAFICO
      )

      if (index !== -1) {
        const updatedGraphic = {
          ...this.graphics[index],
          ATRIBUTOS: updatedAttributes,
          GEOMETRIA: updatedGeometry
        }

        this.$set(this.graphics, index, updatedGraphic)
      }
    },
    onDrawDeleted(idGrafico) {
      const index = this.graphics.findIndex(
        (x) => this.parseAtributos(x.ATRIBUTOS).ID_GRAFICO === idGrafico
      )
      if (index !== -1) {
        this.graphics.splice(index, 1)
      }
    },
    parseAtributos(atributos) {
      return typeof atributos === 'string' ? JSON.parse(atributos) : atributos
    },
    // Cancela el dibujo actual
    cancelCurrentDrawing() {
      this.isDrawing = false
      this.activeBtn = null
      ArcGIS.paintEventPerimetro('cancel')
    },
    finishDrawing() {
      this.showPerimeterSymbology = false
      this.showSnackBar = false
      this.isDrawing = false
      this.activeBtn = null
      ArcGIS.stopPerimeterSketchViewModel()
      this.callback(this.graphics)
      this.callback = null

      this.$store.dispatch('map/clearActiveDrawSymbologyPanel')
    }
    // #endregion
  }
}
</script>
<style scoped>
</style>
